export const endpoints = [
  {
    method: 'GET',
    path: '/v1/cities',
    summary: 'List all available cities with their delivery prices',
    auth: 'X-API-Key',
    parameters: [],
    responses: [
      {
        code: 200,
        description: 'List of cities',
      },
      {
        code: 401,
        description: 'Missing or invalid API key',
      },
    ],
  },

  {
    method: 'GET',
    path: '/v1/products',
    summary: 'List products available to the seller (with variants and SKUs)',
    auth: 'X-API-Key',
    parameters: [
      {
        name: 'category_id',
        type: 'integer',
        required: false,
        description: 'Filter by category id',
      },
      {
        name: 'search',
        type: 'string',
        required: false,
        description: 'Search products by name or description',
      },
      {
        name: 'per_page',
        type: 'integer',
        required: false,
        description: 'Number of results per page (default 15, max 100)',
      },
    ],
    responses: [
      {
        code: 200,
        description: 'List of products',
      },
      {
        code: 401,
        description: 'Missing or invalid API key',
      },
    ],
  },

  {
    method: 'GET',
    path: '/v1/orders',
    summary: 'List all orders of the seller',
    auth: 'X-API-Key',
    parameters: [
      {
        name: 'status',
        type: 'string',
        required: false,
        description:
          'Filter by order status (nouveau, confirme, livre, retour, annule, refuse)',
      },
      {
        name: 'per_page',
        type: 'integer',
        required: false,
        description: 'Number of results per page (default 15, max 100)',
      },
    ],
    responses: [
      {
        code: 200,
        description: 'List of orders',
      },
      {
        code: 401,
        description: 'Missing or invalid API key',
      },
    ],
  },

  {
    method: 'POST',
    path: '/v1/orders',
    summary: 'Create a new order and return the generated order code',
    auth: 'X-API-Key',
    parameters: [
      {
        name: 'name',
        type: 'string',
        required: true,
        description: 'Customer full name',
      },
      {
        name: 'phone',
        type: 'string',
        required: true,
        description: 'Customer phone number',
      },
      {
        name: 'city',
        type: 'string',
        required: true,
        description: 'Customer city',
      },
      {
        name: 'address',
        type: 'string',
        required: true,
        description: 'Customer address',
      },
      {
        name: 'comment',
        type: 'string',
        required: false,
        description: 'Order comment',
      },
      {
        name: 'items[][sku]',
        type: 'string',
        required: true,
        description:
          'Product or variant SKU (e.g. NEXT-5 or VAR-5-2)',
      },
      {
        name: 'items[][quantity]',
        type: 'integer',
        required: true,
        description: 'Quantity of the item',
      },
    ],
    responses: [
      {
        code: 201,
        description: 'Order created with its code',
      },
      {
        code: 401,
        description: 'Missing or invalid API key',
      },
      {
        code: 422,
        description: 'Validation failed or unknown SKU',
      },
    ],
  },
];